export const config = {
  api: {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api',
    timeout: 30000,
  },
  // Shared HMAC secret used by the public Live Wall client to sign
  // requests to GET /public/live-wall/:token. The backend re-computes the
  // signature and rejects 401 when it doesn't match. See
  // `src/api/liveWallSignature.js` for the canonical signing string.
  liveWall: {
    hmacSecret: import.meta.env.VITE_LIVE_WALL_HMAC_SECRET || '',
  },
  app: {
    name: 'MDG Guardian',
    version: '1.0.0',
    // Origin of the super-admin UI — used by the remote-login flow to
    // bounce the user back when their 1h bearer expires. Default is the
    // local super-admin dev port; override per environment via
    // VITE_APP_SUPER_ADMIN_ORIGIN.
    superAdminOrigin: import.meta.env.VITE_APP_SUPER_ADMIN_ORIGIN || 'http://localhost:3000',
  },
}
